import React, { useState } from "react";

const ChatForm: React.FC = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    message: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
  };

  return (
    <form
      onSubmit={handleSubmit}
      className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8"
    >
      <div className="flex gap-4 md:col-span-2 md:w-full">
        <div className="flex flex-col">
          <label htmlFor="firstName" className="mb-1">
            First Name <span className="text-xs">(required)</span>
          </label>
          <input
            type="text"
            name="firstName"
            id="firstName"
            required
            className="py-3 px-5 rounded-lg focus:outline-none w-full"
            value={formData.firstName}
            onChange={handleChange}
          />
        </div>
        <div className="flex flex-col">
          <label htmlFor="lastName" className=" mb-1">
            Last Name <span className="text-xs">(required)</span>
          </label>
          <input
            type="text"
            name="lastName"
            id="lastName"
            required
            className="py-3 px-5 rounded-lg focus:outline-none w-full"
            value={formData.lastName}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="flex flex-col md:col-span-2">
        <label htmlFor="email" className=" mb-1">
          Email <span className="text-xs">(required)</span>
        </label>
        <input
          type="email"
          name="email"
          id="email"
          required
          className="py-3 px-5 rounded-lg focus:outline-none w-full"
          value={formData.email}
          onChange={handleChange}
        />
      </div>
      <div className="flex flex-col md:col-span-2">
        <label htmlFor="subject" className=" mb-1">
          Subject <span className="text-xs">(required)</span>
        </label>
        <input
          type="text"
          name="subject"
          id="subject"
          required
          className="py-3 px-5 rounded-lg focus:outline-none w-full"
          value={formData.subject}
          onChange={handleChange}
        />
      </div>
      <div className="flex flex-col md:col-span-2">
        <label htmlFor="message" className=" mb-1">
          Message <span className="text-xs">(required)</span>
        </label>
        <textarea
          name="message"
          id="message"
          rows={4}
          required
          className="py-3 px-5 rounded-lg focus:outline-none w-full"
          value={formData.message}
          onChange={handleChange}
        />
      </div>
      <div className="md:col-span-2 flex justify-start">
        <button
          type="submit"
          className="bg-black text-white py-3 px-5 mx-auto rounded-lg font-medium uppercase transition-colors"
        >
          Submit
        </button>
      </div>
    </form>
  );
};

export default ChatForm;
